import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MeasurementSystemEnum } from '@cai-services';
import { MeasurementUnit } from '../../../../core/_models/measurement-system.model';
import { CaiLoadTypeQuantityInputBaseComponent } from './load-type-quantity-input-base.component';

@Component({
  selector: 'cai-load-type-quantity-input',
  templateUrl: './load-type-quantity-input.component.html',
  styleUrls: ['./load-type-quantity-input.component.scss'],
  standalone: false,
})
export class CaiLoadTypeQuantityInputComponent extends CaiLoadTypeQuantityInputBaseComponent {
  @Input() placeholder: string;
  @Input() forceErrorDisplay: boolean;
  @Input() weightUnit: MeasurementUnit;
  @Output() onFocus = new EventEmitter();

  measurementSystemEnum = MeasurementSystemEnum;

  matchMeasurementSystem(type: MeasurementSystemEnum) {
    if (
      this.weightUnit?.code === 'kg' &&
      type === MeasurementSystemEnum.METRIC
    ) {
      return true;
    }
    if (
      this.weightUnit?.code === 'lb' &&
      type === MeasurementSystemEnum.IMPERIAL
    ) {
      return true;
    }
    return false;
  }

  get isTurkish(): boolean {
    return window.location.href?.indexOf('/tr/') >= 0;
  }
}
